import React from 'react';
import get from 'lodash/get';
import noop from 'lodash/noop';
import Dropdown from '../Dropdown';
import './styles.css';

export default class HubsSelectField extends React.PureComponent {
  dropdownRef = null;
  constructor(props) {
    super(props);
    this.dropdownRef = React.createRef();
  }

  onChange = (event, { value }) => {
    const closeAction = get(this, 'dropdownRef.current.close', noop);

    this.props.onChange(event, { value });
    closeAction();
  };
  render() {
    return (
      <Dropdown
        ref={this.dropdownRef}
        {...this.props}
        selection
        onChange={this.onChange}
      />
    );
  }
}
